export const cardsPriority = [
  'Needs more',
  'Recently viewed',
  'Started',
  'Almost done',
  undefined,
];

type Card = {
  data?: {
    badge?: {
      text?: string;
    };
  };
};

export const sortByStatus = <T extends Card>(
  arr: T[],
  priority: (string | undefined)[]
) => {
  return !arr?.length
    ? ([] as T[])
    : arr.sort(
        (a, b) =>
          priority.indexOf(a.data?.badge?.text) -
          priority.indexOf(b.data?.badge?.text)
      );
};
